import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  stkRcptSync05ResetTimestamp: ['currentPage', 'sorts', 'filters', 'pageSize'],
  stkRcptSync05GoToDocument: ['hdrId'],
  stkRcptSync05FetchStkRcptSync05: ['currentPage', 'sorts', 'filters', 'pageSize'],
  stkRcptSync05FetchStkRcptSync05Loading: ['boolean'],
  stkRcptSync05FetchStkRcptSync05Success: [
    'documents',
    'currentPage',
    'lastPage',
    'total',
    'pageSize'
  ],
  stkRcptSync05AddSelectedDocuments: ['selectedDocuments'],
  stkRcptSync05RemoveSelectedDocuments: ['selectedDocuments'],
  stkRcptSync05SetWorkspaceVisible: ['boolean'],

  stkRcptSync05SyncNow: ['hdrIds'],
  stkRcptSync05SyncNowSuccess: null,
  stkRcptSync05SyncLoading: ['boolean']
});

export const StkRcptSync05Types = Types;
export default Creators;
